module.exports = __webpack_public_path__ + "static/media/card-game-item.2a0f59af.png";